import { gql } from "@apollo/client";

const UPDATE_BOT = gql`
  mutation UpdateBot($botId: String!, $input: UpdateBotInput!) {
    updateBot(botId: $botId, input: $input) {
      success
      error
      bot {
        id
        botId
        name
        description
        systemPrompt
        handoffEnabled
        primaryColor
        secondaryColor
        backgroundColor
        borderRadius
        position
        avatarUrl
        launcherImageUrl
        darkMode
        welcomeMessage
        placeholderText
        autoOpen
        autoOpenDelay
        typingAnimation
        botTakeoverName
        agentTakeoverName
        enabled
        links
        createdAt
        updatedAt
      }
    }
  }
`;

export default UPDATE_BOT;
